<template lang="pug">
  .container-recharge-apply.container-padding
    c-header
      h3(slot="left") 商家充值审批
    c-box
      el-form(:model="filters",label-position="right",label-width="125px")
        el-row(:gutter="10")
          el-col(:span="12")
            el-form-item(label="申请时间")
              el-date-picker(v-model="date", type="datetimerange", placeholder="选择时间范围")
            el-form-item(label="状态")
              el-select(v-model="filters.biz_status",style="width:280px;" clearable)
                el-option(:value="null", label="全部")
                el-option(v-for="n in 2", :key="n", :value="n", :label="n | biz_status")
            el-form-item(label="营销账号")
              el-select(v-model="filters.outlay_account_id" placeholder="请选择营销账号",style="width:280px;" clearable)
                el-option(v-for="item in outlayAccountList" :key="item.outlay_account_id" :label="item.account_name" :value="item.outlay_account_id")
          el-col(:span="12")
            el-form-item(label="充值流水号")
              el-input(v-model="filters.apply_id")
            el-form-item(label="")
              el-button(@click="setFilter", type="primary") 搜索
              el-button(@click="timeReset") 重置时间
              el-button(@click="clearFilter", v-show="hasFilter") 清除
            //- el-form-item(label="")
              el-button(type="primary", @click="toAuditSelected(1)", :disabled="selectedItem.length <= 0") 确认选中项充值
              el-button(type="primary", @click="toAuditSelected(2)", :disabled="selectedItem.length <= 0") 驳回选中项充值
            //-   el-button(type="primary", @click="showOrder") 创建充值单
    c-box
      el-table(:data="list", fit, v-loading="listLoading", @selection-change="selectItem", size="small", border)
        el-table-column(type="selection", width="50")
        el-table-column(property="id", label="充值流水号", min-width="100", show-tooltip-when-overflow)
        el-table-column(property="create_time", label="申请时间", min-width="150", show-tooltip-when-overflow)
        el-table-column(property="mch_name", label="商家名称", min-width="125", show-tooltip-when-overflow)
        el-table-column(property="outlay_account_name", label="营销账户", min-width="125", show-tooltip-when-overflow)
        el-table-column(label="充值金额", min-width="100", show-tooltip-when-overflow, v-slot="{ row }") {{ row.recharge_amount | toYuan }}
        el-table-column(label="确认人", min-width="100", show-tooltip-when-overflow, v-slot="{ row }") {{ row.confirm_user_name }}
        el-table-column(label="状态", min-width="125", show-tooltip-when-overflow, v-slot="{ row }") {{ row.status | status }}
        el-table-column(label="操作", min-width="75", align="right", v-slot="{ row }")
          el-button(type="primary", size="small", @click="showDetail(row)") 详情
        el-table-column(label="用户确认", min-width="150", align="right", v-slot="{ row }")
          el-button(type="primary", size="small", @click="audit(row.id)", v-if="row.status===4") 确认充值
          el-button(type="primary", size="small", @click="audit(row.id)", v-if="row.status===5") 确认充值
      .container-pagination
        el-pagination(layout="sizes, prev, pager, next, total",
          :current-page="page", :total="total", :page-size="size", :page-sizes="[5, 10, 15, 20, 25, 50]",
          @size-change="changeListSize", @current-change="getList")

    el-dialog(title="充值审批详情", :visible.sync="detail.show", top="5%")
      el-form(:model="detail.source", label-position="right", label-width="150px")
        el-form-item(label="充值流水号") {{ detail.source.id }}
        el-form-item(label="申请时间") {{ detail.source.create_time }}
        el-form-item(label="商家名称") {{ detail.source.mch_name }} （{{ detail.source.mch_id }}）
        el-form-item(label="营销账户") {{ detail.source.outlay_account_name }}（{{ detail.source.outlay_account_id }}）
        el-form-item(label="充值类型") {{ detail.source.recharge_type | outlay_act_type }}
        el-form-item(label="充值金额") {{ parseFloat(detail.source.recharge_amount) >= 0 ? '+' : '-' }}{{ detail.source.recharge_amount | toYuan }}
        el-form-item(label="确认人") {{ detail.source.confirm_user_name }}
        el-form-item(label="转账凭证")
          .img-container(v-if="detail.source.pic_array.length > 0", v-for="(p, $index) in detail.source.pic_array")
            img(:src="p", @click="$zoom(p)").img-thumbnail
          template(v-if="detail.source.pic_array.length === 0") 未上传任何图片
        el-form-item(label="备注") {{ detail.source.remark }}
        el-form-item(label="应用订单号或标识") {{ detail.source.outer_bill_id }}
        //- el-form-item(label="申请人") {{ detail.source.apply_user_name }}
        el-form-item(label="状态") {{ detail.source.status | status }}
        el-form-item(label="驳回原因", v-if="detail.source.status === 7") {{ detail.source.reason }}
      .dialog-footer(slot="footer")
        //- el-button(type="primary", @click="toAuditOne(detail.source, 1)") 通过
        el-button(type="primary", size="small", @click="audit(detail.source.id)", v-if="detail.source.status===4") 确认充值
        el-button(type="primary", size="small", @click="audit(detail.source.id)", v-if="detail.source.status===5") 确认充值
        el-button(@click="hideDetail()") 关闭
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      size: 10,
      list: [],
      total: 0,
      selectedItem: [],
      listLoading: false,
      order: {
        show: false,
        pic_url_array: []
      },
      filters: {
        apply_id: "",
        biz_status: "",
        outlay_account_id: ""
      },
      date: [],
      hasFilter: false,
      outlayAccountList: [],
      detail: {
        show: false,
        source: {
          pic_array: []
        },
        log: []
      }
    };
  },
  filters: {
    status(source) {
      switch (source) {
        case 1:
          return "资料待完善";
          return "待商家确认";
        case 2:
          return "待运营审批";
        case 3:
          return "运营审批通过";
        case 4:
          return "待商家审批确认";
        case 5:
          return "待商家审批确认";
        case 6:
          return "充值成功";
        case 7:
          return "充值成功";
        default:
          return source;
      }
    },
    biz_status(source) {
      switch (source) {
        case 1:
          return "待商家确认";
        case 2:
          return "充值成功";
        default:
          return source;
      }
    },
    fix_status(source) {
      switch (source) {
        case 1:
          return "资料待完善";
        case 2:
          return "商户提交审核";
        case 3:
          return "审批通过";
        case 4:
          return "审批通过";
        case 5:
          return "财务已确认";
        case 6:
          return "审核成功";
        case 7:
          return "审核失败";
        default:
          return source;
      }
    }
  },
  methods: {
    // 商家确定
    audit(apply_id) {
      this.$store
        .dispatch("CONFIRM_RECHARGE_APPLY", apply_id)
        .then(data => {
          this.detail.show = false;
          this.$message.success("确定成功");
          this.getList();
          //   console.log(data);
        })
        .catch(({ msg }) => {
          this.$alert(`${msg}`, {
            type: "error"
          });
        });
    },
    // 获取营销账户
    getOutlayAccountList() {
      this.$store
        .dispatch("GET_OUTLAY_ACCOUNT_LIST", { limit: 50 })
        .then(data => {
          this.outlayAccountList = data.list;
        })
        .catch(({ msg }) => {
          this.$alert(`${msg}`, {
            type: "error"
          });
        });
    },
    showDetail(row) {
      let pic_array = [];
      if (row.pic_urls && row.pic_urls.startsWith("[")) {
        pic_array = JSON.parse(row.pic_urls);
      } else if (row.pic_urls) {
        pic_array = row.pic_urls.split(",");
      }

      this.detail = {
        show: true,
        source: Object.assign({}, row, {
          pic_array
        }),
        log: []
      };
      this.getDetailLog(row.id);
    },
    showOrder() {
      this.order.show = true;
    },
    hideDetail() {
      this.detail = {
        show: false,
        source: {
          pic_array: []
        },
        log: []
      };
    },
    getDetailLog(id) {
      return this.$store
        .dispatch("GET_RECHARGE_APPLY_LOG", id)
        .then(data => {
          if (this.detail.show) {
            this.detail.log = [...data];
          }
          return data;
        })
        .catch(({ msg }) => {
          this.$message({
            type: "error",
            message: `获取充值审批记录失败。${msg}`
          });
        });
    },

    toAuditOne({ id, audit_role_type }, status) {
      this.toAuditMultiple([id], status, audit_role_type);
    },
    toAuditSelected(status) {
      if (this.selectedItem.length === 0) {
        this.$message({
          type: "warning",
          message: `未选择任何审批条目`
        });
        return;
      }

      let id_array = [];
      let audit_role_type = null;
      let same_role_flag = true;
      this.selectedItem.forEach(v => {
        id_array.push(v.id);
        if (audit_role_type === null) {
          audit_role_type = v.audit_role_type;
        } else if (audit_role_type !== v.audit_role_type) {
          same_role_flag = false;
        }
      });
      if (same_role_flag) {
        this.toAuditMultiple(id_array, status, audit_role_type);
      } else {
        this.$message({
          type: "warning",
          message: `已选择的审批条目中包含当前审批角色与其他不一致的条目`
        });
      }
    },
    toAuditMultiple(id_array, status, audit_role_type) {
      if (status === 2) {
        this.$prompt("请输入驳回当前选中的充值申请原因", "驳回充值申请", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputValue: "",
          inputPattern: /\S/,
          inputErrorMessage: `请输入原因`
        })
          .then(({ value }) => {
            this.toAudit(id_array, status, value, audit_role_type);
          })
          .catch(() => {});
      } else if (status === 1) {
        this.$confirm("是否确认通过当前选中的充值申请？", "确认充值申请", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.toAudit(id_array, status, "", audit_role_type);
          })
          .catch(() => {});
      }
    },
    toAudit(id_array, status, remark, audit_role_type) {
      const ids = JSON.stringify(id_array);
      const params = { ids, status, remark, audit_role_type };

      return this.$store
        .dispatch("AUDIT_RECHARGE_APPLY", params)
        .then(() => {
          this.$message({
            type: "success",
            message: `审批成功`
          });

          this.hideDetail();
          this.refresh();
        })
        .catch(({ msg }) => {
          this.$message({
            type: "error",
            message: `审批失败。${msg}`
          });
        });
    },
    timeReset() {
      this.date = [];
      this.refresh();
    },

    setFilter() {
      if (
        this.filters.status ||
        this.filters.id ||
        (Array.isArray(this.date) && this.date.length === 2)
      ) {
        this.hasFilter = true;
      } else {
        this.hasFilter = false;
      }

      this.getList(1);
    },
    clearFilter() {
      this.timeReset();
      this.filters = {
        id: null,
        status: null
      };
      this.hasFilter = false;
      this.getList(1);
    },
    getFilter() {
      let start_date = null;
      let end_date = null;

      const date = this.date;
      if (Array.isArray(date) && date.length === 2) {
        start_date = this.$datetimeFormatter(date[0]);
        end_date = this.$datetimeFormatter(date[1]);
      }

      const filters = Object.assign({}, this.filters, {
        start_date,
        end_date
      });
      return filters;
    },

    refresh() {
      this.getList(this.page);
    },
    changeListSize(size = 10) {
      this.size = size;
      this.getList(1);
    },

    selectItem(val) {
      this.selectedItem = val;
    },

    getList(page = 1) {
      if (!this.listLoading) {
        this.page = page;
        this.listLoading = true;
      } else {
        return;
      }

      const _filters = this.getFilter();
      //   console.log("_filters", _filters);
      this.$store
        .dispatch(
          "QUERY_RECHARGE_APPLY",
          Object.assign(
            {
              offset: this.size * (this.page - 1),
              limit: this.size,
              stat: true
            },
            _filters
          )
        )
        .then(data => {
          this.list = data.list;
          this.total = data.total;
        })
        .catch(({ msg }) => {
          this.$alert(`${msg}`, {
            type: "error"
          });
        })
        .finally(() => {
          this.listLoading = false;
        });
    }
  },
  mounted() {
    this.getList(1);
    this.getOutlayAccountList();
  }
};
</script>

<style lang="less">
.container-recharge-apply {
  .el-step.is-vertical .el-step__line {
    top: 8px;
    bottom: -8px;
  }
}
</style>
